<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Product Plan</li>
		</ol>

        <h1 class="page-header">Product Plan</h1>
        <hr>

        <vue-universal-table 
            class="mt-3"
            :indexing="true"
            :dummy="true"
            api_url="/api/product_plan"
            :buttons="table.buttons"
            :update="table.update"
            :special_buttons="table.special_buttons"
            :process_data='table.process_data'
            @onNewPlan="modal.add = true"
            @onDelete="deletePlan"
            @onEdit="editPlan"
            :fields="table.fields"
        />

        <transition name="modal" v-if="modal.edit">
            <div class="modal-mask">
                <div class="modal-wrapper" @click="modal.edit = false">
                    <div class="row">
                        <div class="col-xs-1 col-sm-1 col-md-2 col-lg-3"></div>
                        <div class="col-xs-10 col-sm-10 col-md-8 col-lg-6">
                            <div class="modal-container" @click.stop>
                                <div class="modal-body">
                                    <AddProductPlan 
                                        :method="'put'"
                                        :title="'Edit'"
                                        :dataDetail="dataDetail"
                                        @closeModal="modal.edit = false"
                                        @updateTable="table.update++"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-3"></div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="modal" v-if="modal.add">
            <div class="modal-mask">
                <div class="modal-wrapper" @click="modal.add = false">
                    <div class="row">
                        <div class="col-xs-1 col-sm-1 col-md-2 col-lg-3"></div>
                        <div class="col-xs-10 col-sm-10 col-md-8 col-lg-6">
                            <div class="modal-container" @click.stop>
                                <div class="modal-body">
                                    <AddProductPlan 
                                        :method="'post'"
                                        :title="'Add'"
                                        @closeModal="modal.add = false"
                                        @updateTable="table.update++"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-3"></div>
                    </div>
                </div>
            </div>
        </transition>

        

    </div>
</template>

<script>
import AddProductPlan from './childComponents/addPlan'

export default {
    data(){
        return {
            modal : {
                add : false,
                edit : false
            },
            table : {
                buttons : [{
                    title : 'Edit',
                    class : 'fa fa-edit btn btn-primary'
                }, {
                    title : 'Delete',
                    variable : 'id',
                    class : 'fa fa-times-circle btn btn-danger'
                }],
                process_data : `
                   
                `,
                update : 0,
                special_buttons: ['NewPlan'],
                fields : [{
                    title : 'Location Code',
                    variable : 'loc_code',
                },{
                    title : 'Daily',
                    variable : 'daily',
                    number_formatting: true
                }, {
                    title : 'Monthly',
                    variable : 'monthly',
                    number_formatting : true
                }, {
                    title : 'Status',
                    variable : 'status'
                }, {
                    title : 'Date',
                    variable : 'created_at'
                }]
            },
            dataDetail : null
        }
    },
    components : {
        AddProductPlan
    },
    methods : {
        editPlan(dat) {
            this.dataDetail = JSON.parse(dat)

            this.modal.edit = true
        },
        deletePlan(id) {
            // alert(id)
            id = id.split('"').join('')

            this.$http.delete(`/api/product_plan/${id}`)
            .then((resp) => {
                console.log('Success' , resp.data.data)
                this.table.update++
            })
            .catch((err)=> {
                alert(err)
            })
        }
    }
}
</script>

<style>
    .statusFailed{
        color: #ff7152;
    }
    .statusSuccess{
        color: #68edb6;
    }
    .statusStyle{
        font-weight: bold;
    }
    th{
        text-align: center;
    }
    td{
        text-align: center;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body{
        margin:0
    }

    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a{
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }

    h3.modalHeadline{
        margin:0 0 20px 0
    }
    /* MODAL ENDS */

    .modalContent tr th{
      text-align:right;
    }

    .modalContent tr .middleDivider{
      width: 50px;
      text-align: center;
    }
    .headTitle{
        cursor: pointer;
    }
    .page-link{
        cursor: pointer;
    }
    .pageNumber .page-link:hover{
        background-color: white;
        cursor: default;
    }
    .disabled .page-link{
        background-color:#EEEEEE;
    }
    li .disabled:hover{
        cursor: default;
    }
    .table-div{
        display: block;
        overflow: scroll;
    }
</style>